import callOfDuty from 'assets/images/game_icons/game-icon-call-of-duty_9.6.26.webp';
import warzone from 'assets/images/game_icons/game-icon-warzone_9.6.26.webp';
import halo from 'assets/images/game_icons/game-icon-halo_9.6.26.webp';
import leagueOfLegends from 'assets/images/game_icons/game-icon-league-of-legends_9.6.26.webp';
import rocketLeague from 'assets/images/game_icons/game-icon-rocket-league_9.6.26.webp';
import valorant from 'assets/images/game_icons/game-icon-valorant_9.6.26.webp';
import cs2 from 'assets/images/game_icons/game-icon-counter-strike-2_9.6.26.webp';

/**
 * Game icon art, keyed by the entry `slug` every catalog shares -- see
 * gameAliases.js for the same pattern applied to search aliases.
 */
export const GAME_ICONS = {
    'call-of-duty': callOfDuty,
    'warzone': warzone,
    'halo': halo,
    'league-of-legends': leagueOfLegends,
    'rocket-league': rocketLeague,
    'valorant': valorant,
    'cs2': cs2,
};
